var render = function render(){var _vm=this,_c=_vm._self._c;return _c('focus-trap',{model:{value:(_vm.trapActive),callback:function ($$v) {_vm.trapActive=$$v},expression:"trapActive"}},[_c('b-modal',_vm._g(_vm._b({ref:"modal"},'b-modal',_vm.bindReferences,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }